import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/testimonials";

export default function TestimonialWall() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Voices"
          title="吃瓜群众说"
          desc="来自每天都会点开看一眼的朋友们。"
          align="center"
        />
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
              <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700 flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-background-200">
                <span className="w-11 h-11 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    title={`${item.name} - 51吃瓜读者`}
                    className="w-full h-full object-cover object-top"
                  />
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">
                    {item.name}
                  </span>
                  <span className="block text-xs text-foreground-400">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}

          <div className="flex flex-col justify-center rounded-lg bg-primary-500 text-background-50 p-6">
            <i className="ri-group-line text-3xl"></i>
            <p className="mt-4 font-heading font-black text-2xl">每天 3 万+</p>
            <p className="mt-1 text-sm text-background-100/85">
              位吃瓜群众在这里查看今天有什么瓜。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}